import type { SignInIdentifier } from '@logto/schemas';
import { useContext } from 'react';

import UserInteractionContext from '@/Providers/UserInteractionContextProvider/UserInteractionContext';
import TextLink from '@/components/TextLink';
import { UserFlow } from '@/types';

type Props = {
  readonly identifier?: SignInIdentifier;
  readonly value?: string;
  readonly className?: string;
};

const ForgotPasswordLink = ({ className, ...identifierData }: Props) => {
  const { setForgotPasswordIdentifierInputValue } = useContext(UserInteractionContext);

  return (
    <TextLink
      className={className}
      text="action.forgot_password"
      to={`/${UserFlow.ForgotPassword}`}
      onClick={() => {
        setForgotPasswordIdentifierInputValue({
          type: identifierData.identifier,
          value: identifierData.value ?? '',
        });
      }}
    />
  );
};

export default ForgotPasswordLink;
